export default "__VITE_ASSET__d5710321__"